import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../../components";
import { IntersectingInfiniteLoadingButton } from "../../../components/infiniteLoading/IntersectingInfiniteLoadingButton";
import { NavigationBar } from "../../../components/navigation/NavigationBar";
import { DISCOVER, ORDER_BUYER } from "../../../constants/routes";
import { useSupplierRecentlyAddedNew } from "../../../hooks/api/v2/supplier/useSupplierRecentlyAddedNew";
import { useNavigateToChild } from "../../../hooks/useParentNavigation";
import { DiscoveryListSupplierCard } from "./DiscoveryListSupplierCard";

export const DiscoveryV2SuppliersRecentList = () => {
  const navigate = useNavigate();
  const navigateToChild = useNavigateToChild();
  const recentlyAddedSuppliersQuery = useSupplierRecentlyAddedNew({});
  const suppliers =
    recentlyAddedSuppliersQuery.data?.pages.flatMap((page) => page) ?? [];

  const { isLoading } = recentlyAddedSuppliersQuery;
  if (isLoading) return <SpinnerLegacy />;

  return (
    <>
      <NavigationBar
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={() => {
          navigate(DISCOVER);
        }}
        title={"Recently added suppliers"}
      />
      <div className="m-auto flex w-[100vw] max-w-[1200px] flex-col gap-4 p-4 transition-opacity min-[640px]:w-[88vw] min-[1280px]:w-[79vw] md:pt-10">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {suppliers.map((supplier) => (
            <DiscoveryListSupplierCard
              key={supplier.id}
              supplier={supplier}
              onClick={() =>
                navigateToChild(
                  ORDER_BUYER.href({ supplierIdOrUrlId: supplier.urlId }),
                )
              }
            />
          ))}
        </div>
        <IntersectingInfiniteLoadingButton
          query={recentlyAddedSuppliersQuery}
        />
      </div>
    </>
  );
};
